import { render } from "./courtClients.vue?vue&type=template&id=7c2be570"
import script from "./courtClients.vue?vue&type=script&lang=js"
export * from "./courtClients.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__